export default __webpack_public_path__ + "static/media/icon-1.b3db9e4b.svg";